import React from 'react';
import { getIcon, getColor } from '@/lib/icons';

// Renders an app's custom image icon if set, otherwise the chosen preset icon.
export function AppIcon({ app, size = 44, iconClass = 'h-5 w-5', rounded = 'rounded-xl', className = '' }) {
  const color = getColor(app?.color);
  const style = { width: size, height: size };
  if (app?.icon_image) {
    return (
      <span className={`overflow-hidden border border-[color:var(--cx-border)] ${rounded} ${className}`} style={style}>
        <img src={app.icon_image} alt={app?.name || 'app'} className="h-full w-full object-cover" />
      </span>
    );
  }
  const Icon = getIcon(app?.icon);
  return (
    <span className={`flex items-center justify-center border border-[color:var(--cx-border)] ${rounded} ${className}`}
      style={{ ...style, background: `linear-gradient(135deg, ${color.from}22, ${color.to}14)` }}>
      <Icon className={iconClass} style={{ color: color.from }} />
    </span>
  );
}
